function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_73",
  "data-name": "Group 73",
  transform: "translate(-706 -227)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  transform: "translate(706 227)",
  fill: "#0a9ba9",
  stroke: "#00788f",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "icons_ui_down",
  "data-name": "icons/ui/down",
  transform: "translate(709.412 231.499)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M42.562,6.343a.343.343,0,0,1,0-.5l.526-.5a.383.383,0,0,1,.525,0l1.678,1.625,4.176-4.035a.384.384,0,0,1,.526,0l.526.5a.345.345,0,0,1,0,.5l-4.964,4.79a.386.386,0,0,1-.526,0Z",
  transform: "translate(-42.453 -2.825)",
  fill: "#fff",
  fillRule: "evenodd"
})));

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.22eade7f.svg";
export { ForwardRef as ReactComponent };